import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const Badge = styled.div`
  width: 14px;
  height: 14px;
  background-color: rgba(170, 170, 170, 0.2);
  border-radius: 50%;
  position: relative;
  ${({ withMargin }) => (withMargin ? 'margin-right: 10px;' : 'margin: 0 10px 0 10px;')};
  ${({ color }) => css`
    &:before {
      content: ' ';
      inset: 0;
      margin: auto;
      width: 8px;
      height: 8px;
      position: absolute;
      border-radius: 50%;
      opacity: 1;
      background-color: ${color};
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/task-item/task-priority/styles.js